import React from 'react';
import { TimeRangeButton, TimeRangeNavigator } from '../ui';

const TimeNavigatorBar = () => (
  <div className="flex justify-between mb3">
    <div className="flex">
      <TimeRangeButton />
      <TimeRangeNavigator />
    </div>
  </div>
);

export default TimeNavigatorBar;
